import { useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { WorkTypeDDL } from "../../../../../Components/CommonDDL/WorkTypeDDL"

export const AllContain = (props) => {

    const { SetActiveBtn, ActiveBtn, WorkType, setWorkType } = props
    const Navigate = useNavigate()



    return (

        <>
            <div className="row  m-0 mb-3 master_border">

                <div className="col-2 py-2 " >
                    <input type="date" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com"></input>
                </div>

                <div className="col-3 py-2 " >
                    {
                        ActiveBtn == "Garden Work Assigned by Officials" &&
                        <WorkTypeDDL
                            isDisplay={false}
                            WorkType={WorkType}
                            setWorkType={setWorkType}
                            ActiveBtn="Dashboard Official Visit"
                        />

                    }
                </div>

                <div className="col-7 py-2 " >
                    <div className="btn-group float-end " role="group" aria-label="Default button group">
                        <button type="button" className={ActiveBtn === "Garden Work Assigned by Officials" ? "active_group_btn border_radiusn" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("Garden Work Assigned by Officials")}> Official Visit</button>
                        <button type="button" className={ActiveBtn === "Work Assign By Officials" ? "active_group_btn" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("Work Assign By Officials")}>Work  Assign By Officials</button>
                        <button type="button" className={ActiveBtn === "Work Progress by Contractor" ? "active_group_btn" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("Work Progress by Contractor")}>Work Progress by Contractor</button>
                        <button type="button" className={ActiveBtn === "Reopen Work Progress" ? "active_group_btn border_radius2" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("Reopen Work Progress")}>Reopen Work Progress</button>
                    </div>
                </div>

            </div>
        </>
    )
}